<template>
  <template v-if="isQuoteField">
    <!-- 引用数字 -->
    <jw-input-number v-if="modulesItem?.setting?.business?.fieldType == 7" :precision="getPrecision(modulesItem, precisionNum)" v-model="modulesItem.fieldValue" class="system-form-item-fields ly-form-item-fields-disabled" :placeholder="quoteFieldPlaceholder" hide-button disabled>
      <template #append> % </template>
    </jw-input-number>

    <!-- 引用计算数字 -->
    <jw-input-number v-else class="system-form-item-fields computed-fields ly-form-item-fields-disabled" v-model="modulesItem.fieldValue" :placeholder="quoteFieldPlaceholder" disabled :formatter="(event) => isShowThousandFormatter(event, modulesItem)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(modulesItem, precisionNum, true)" />
  </template>

  <template v-else-if="JSON.parse(numberExt)?.numberFormat === '100'">
    <jw-input-number :max-length="confine.number5000" :precision="3" v-model="modulesItem.fieldValue" :class="[isTask ? 'task-fields' : 'system-form-item-fields']" :placeholder="modulesItem.placeholder || t('请输入') + modulesItem?.setting?.fieldName" @blur="handleChange" @focus="clearUploadActive" @clear="handleChange" allow-clear hide-button :disabled="modulesItem.businessData == '0' || disabledAll">
      <template #append> % </template>
    </jw-input-number>
  </template>
  <template v-else>
    <template v-if="isFormat">
      <!-- 精度 末尾不省略0 -->
      <jw-input-number ref="inputNumberRef" :max-length="confine.number5000" :class="[isTask ? 'task-fields' : 'system-form-item-fields']" v-model="modulesItem.fieldValue" :placeholder="modulesItem.placeholder || t('请输入') + modulesItem?.setting?.fieldName" @blur="handleChange" @clear="handleChange" @focus="clearUploadActive" allow-clear :disabled="modulesItem.businessData == '0' || disabledAll" :formatter="(event) => isShowThousandFormatter(event, modulesItem)" :parser="(value) => value.replace(/,/g, '')" :precision="tools.isJSON(numberExt) ? Number(JSON.parse(numberExt)?.numberFormat) : 2">
        <template v-if="tools.isJSON(numberExt) && JSON.parse(numberExt)?.numberUnit" #append>
          {{ JSON.parse(numberExt)?.numberUnit || '' }}
        </template>
      </jw-input-number>
    </template>
    <template v-else>
      <!-- 精度 末尾省略0 -->
      <jw-input-number :max-length="confine.number5000" :class="[isTask ? 'task-fields' : 'system-form-item-fields']" v-model="modulesItem.fieldValue" :placeholder="modulesItem.placeholder || t('请输入') + modulesItem?.setting?.fieldName" @focus="handleFocus" allow-clear :disabled="modulesItem.businessData == '0' || disabledAll" :formatter="(event) => isShowThousandFormatter(event, modulesItem)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(modulesItem, precisionNum)">
        <template v-if="tools.isJSON(numberExt) && JSON.parse(numberExt)?.numberUnit" #append>
          {{ JSON.parse(numberExt)?.numberUnit || '' }}
        </template>
      </jw-input-number>
    </template>
  </template>
</template>

<script setup>
import { ref, nextTick, inject, computed } from 'vue';
import { confine } from '@/utils/const.js';
import { useI18n } from 'vue-i18n';
import { tools } from '@/utils/tools.js';
import { useUploadStore } from '@/store';

const uploadStore = useUploadStore();
// 精度
import useThousandOption from '@/hooks/thousand';
const isQuoteField = inject('fhFormFieldsParams')?.isQuoteField;
const quoteFieldPlaceholder = inject('fhFormFieldsParams')?.quoteFieldPlaceholder;

// 处理精度 千分符
const { precisionNum, isShowThousandFormatter, getPrecision } = useThousandOption();
const { t } = useI18n();
const emits = defineEmits(['cb', 'selectPopVisibleCb']);

const props = defineProps({
  modules: {
    type: Object,
    default: () => {}
  },
  isTask: {
    type: Boolean,
    default: false
  },
  disabledAll: {
    type: Boolean,
    default: false
  }
});

const isFormat = ref(false);
const inputNumberRef = ref();

const numberExt = computed(() => {
  return isQuoteField.value ? modulesItem.value?.setting?.business?.fieldExt : modulesItem.value?.setting?.fieldExt;
});
const clearUploadActive = () => {
  uploadStore.clearActive();
};

const handleFocus = () => {
  isFormat.value = true;
  nextTick(() => {
    inputNumberRef.value?.focus();
  });
  clearUploadActive();
};

const modulesItem = ref(props?.modules);
const handleChange = async () => {
  isFormat.value = false;
  await nextTick();
  emits('cb', modulesItem.value);
};
</script>
